import React, {FC} from 'react';
import {useEvents} from 'hooks/useEvents';
import BookingMap from 'pages/booking/components/Map';
import {useParseCoords} from 'pages/booking/components/Map/useParseCoords';
import {LocationProvider, useCreateLocation} from 'pages/booking/components/useLocation';

import * as styles from './styles.module.scss';

type MapProps = {
	region?: string
	coords?: string
	zoom?: string
}

export const Map: FC<MapProps> = ({region, coords, zoom}) => {
	const location = useCreateLocation();
	const init = useParseCoords(coords, zoom);
	const {state} = useEvents({
		region: region || location.configs.region?.key,
	});

	return (
		<LocationProvider location={location}>
			<BookingMap
				className={styles.map}
				region={state.vars.region}
				init={init}
				locations={state.locations}
			/>
		</LocationProvider>
	);
};
